import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Section Components
import NewsCintillo from "./components/sections/NewsCintillo";
import HeroSection from "./components/sections/HeroSection";
import AboutLogo from "./components/sections/AboutLogo";
import FeaturedCollections from "./components/sections/FeaturedCollections";
import CustomTeamGear from "./components/sections/CustomTeamGear";
import WhyGwins from "./components/sections/WhyGwins";
import Community from "./components/sections/Community";
import FeaturedSponsoredTeam from "./components/sections/FeaturedSponsoredTeam";
import GwinsArmy from "./components/sections/GwinsArmy";
import Referrals from "./components/sections/Referrals";
import MerchZone from "./components/sections/MerchZone";
import EmailSignup from "./components/sections/EmailSignup";

// Community Pages
import CommunityHub from "./components/community/CommunityHub";

// Auth Components
import AuthCallback from "./components/auth/AuthCallback";

// Legal Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import ReferralTerms from "./pages/ReferralTerms";

// Referral Dashboard
import ReferralDashboard from "./pages/ReferralDashboard";

// Admin Dashboard
import AdminDashboard from "./pages/AdminDashboard";

// Gallery Page
import Gallery from "./pages/Gallery";

// Common Components
import CookieConsent from "./components/common/CookieConsent";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0b0c]">
      <Header />
      <main>
        <div className="pt-24">
          <NewsCintillo />
        </div>
        <HeroSection />
        <AboutLogo />
        {/* Community Focus First */}
        <Community />
        <FeaturedSponsoredTeam />
        <GwinsArmy />
        {/* The GWINS Difference - Before Shop */}
        <WhyGwins />
        {/* Shop Section - After GWINS Army */}
        <FeaturedCollections />
        {/* CustomTeamGear - Hidden until ready */}
        {/* <CustomTeamGear /> */}
        <Referrals />
        <MerchZone />
        <EmailSignup />
      </main>
      <Footer />
    </div>
  );
};

// AppRouter - Handles session_id detection synchronously during render
const AppRouter = () => {
  const location = useLocation();

  // CRITICAL: Check for session_id in URL fragment SYNCHRONOUSLY during render
  // This prevents race conditions by processing auth callback BEFORE other routes
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/community" element={<CommunityHub />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/referral-terms" element={<ReferralTerms />} />
      <Route path="/referral-dashboard" element={<ReferralDashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/gallery" element={<Gallery />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-center" 
        richColors 
        toastOptions={{
          style: {
            background: '#131416',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff',
          },
        }}
      />
      <BrowserRouter>
        <AppRouter />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
